import React, { useMemo } from "react";

export default function Pagination({ page, totalPages, onChange }) {
  const canPrev = page > 1;
  const canNext = page < totalPages;

  const pagesToShow = useMemo(() => {
    // 1 ... p-1 p p+1 ... last (bem simples)
    const out = new Set([1, totalPages, page, page - 1, page + 1, page - 2, page + 2]);
    return Array.from(out)
      .filter((n) => n >= 1 && n <= totalPages)
      .sort((a, b) => a - b);
  }, [page, totalPages]);

  return (
    <div className="pager">
      <button className="pager__btn" disabled={!canPrev} onClick={() => onChange(page - 1)}>
        ← Anterior
      </button>

      <div className="pager__nums">
        {pagesToShow.map((n, idx) => {
          const prev = pagesToShow[idx - 1];
          const gap = prev && n - prev > 1;

          return (
            <React.Fragment key={n}>
              {gap && <span className="pager__dots">…</span>}
              <button
                className={`pager__num ${n === page ? "isActive" : ""}`}
                onClick={() => onChange(n)}
              >
                {n}
              </button>
            </React.Fragment>
          );
        })}
      </div>

      <button className="pager__btn" disabled={!canNext} onClick={() => onChange(page + 1)}>
        Próximo →
      </button>
    </div>
  );
}